<script setup>
import config from '@/common/config'
import MenuLayout from '@/pages/layout/MenuLayout.vue'
import { onMounted, reactive } from 'vue'
import { useRoute } from 'vue-router'
import Cookies from "js-cookie"
const props=defineProps(['submenus','menutk',]),route=useRoute()
const meta=reactive({persist:false,breadcrumbs:[props.menutk,''],tab:null,inited:false})
const emit = defineEmits(['tabChanged'])
function setSubTtl(tk){
  if(!meta.inited)return
  meta.breadcrumbs[1]=tk
  meta.tab=tk
  let paths=[config.frontRoot]
  route.path.split('/').filter(path=>path&&!props.submenus.includes(path)).forEach(path=>paths.push(path))
  paths=paths.map(path=>path.replaceAll('/',''))
  paths.push(tk)
  history.pushState(history.state, '', '/'+paths.join('/'))
  emit('tabChanged', tk)
}
defineExpose({setSubTtl})
onMounted(()=>{
  meta.inited=true
  let cookiemenu=Cookies.get('admdatamenu')
  if(cookiemenu){
    Cookies.remove('admdatamenu')
    if(location.href.includes('managestyles')){
      cookiemenu='managestyles'
    }
    setSubTtl(cookiemenu)
  }else{
    setSubTtl(route.params.menu||props.submenus[0])
  }
})
</script>
<template>
  <MenuLayout>
    <v-card class="w-100 h-100">
      <v-card-title class="font-weight-black">
        <v-breadcrumbs v-if="meta.breadcrumbs[1]" :items="meta.breadcrumbs">
          <template #item="{item}">{{ $t(item.title) }}</template>
          <template #divider>
            <v-icon icon="mdi-chevron-right"></v-icon>
          </template>
        </v-breadcrumbs>
      </v-card-title>
      <v-tabs show-arrows class="w-100" v-model="meta.tab" bg-color="deep-purple-darken-4" @update:model-value="setSubTtl" @click="$router.push({hash: ''})">
        <v-tab v-for="sm in props.submenus" :value="sm">{{ $t(sm) }}</v-tab>
      </v-tabs>
      <v-card-text>
        <v-tabs-window v-model="meta.tab" class="h-100 overflow-y-auto" style="min-height: 650px;">
          <slot :activeTab="meta.tab"/>
        </v-tabs-window>
      </v-card-text>
    </v-card>
  </MenuLayout>
</template>
